class CustomCart {
  constructor() {
    this.initEventListeners();
  }
  
  initEventListeners() {
    // Listen for custom add to cart form submissions
    document.addEventListener('submit', (event) => {
      const form = event.target;
      
      if (form.id === 'product-form-custom') {
        event.preventDefault();
        this.validateAndAddToCart(form);
      }
    });
  }
  
  validateAndAddToCart(form) {
    // Get required fields
    const phoneModel = form.querySelector('#phone-model');
    const phoneModelError = document.getElementById('phone-model-error');
    
    // Validate phone model
    if (!phoneModel.value.trim()) {
      phoneModelError.style.display = 'block';
      phoneModel.classList.add('error');
      return false;
    }
    
    // If validation passes, add to cart
    this.addToCart(form);
  }
  
  addToCart(form) {
    const formData = new FormData(form);
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.status) {
        // Handle error
        console.error('Error:', data.description);
        // Show error message to user
      } else {
        // Success - update cart count and show confirmation
        this.updateCartCount();
        this.showAddToCartConfirmation();
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }
  
  updateCartCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCountBubble = document.querySelector('.cart-count-bubble');
        const cartCount = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        
        if (cartCount) {
          cartCount.textContent = cart.item_count;
        }
        
        if (cartCountBubble) {
          if (cart.item_count > 0) {
            cartCountBubble.classList.remove('hidden');
          } else {
            cartCountBubble.classList.add('hidden');
          }
        }
      });
  }
  
  showAddToCartConfirmation() {
    // Create or show a confirmation message
    const confirmation = document.createElement('div');
    confirmation.className = 'add-to-cart-confirmation';
    confirmation.innerHTML = `
      <div class="confirmation-content">
        <p>Product added to cart!</p>
        <div class="confirmation-buttons">
          <a href="/cart" class="button">View Cart</a>
          <button class="button button--secondary continue-shopping">Continue Shopping</button>
        </div>
      </div>
    `;
    
    document.body.appendChild(confirmation);
    
    // Add animation class
    setTimeout(() => {
      confirmation.classList.add('active');
    }, 10);
    
    // Add event listener to continue shopping button
    confirmation.querySelector('.continue-shopping').addEventListener('click', () => {
      confirmation.classList.remove('active');
      setTimeout(() => {
        confirmation.remove();
      }, 300);
    });
  }
}

// Initialize the custom cart
document.addEventListener('DOMContentLoaded', () => {
  new CustomCart();
}); 